export default function delay (duration: number, handler?: Promise<void>): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(async () => {
      if (handler) { await handler; }

      resolve();
    }, duration);
  });
}
